/* MDV OOS CTA C — draft-only, 2026-10-22. Never change cart or checkout. */
(() => {
  if (window.__mdvOosCtaCLoaded) return;
  window.__mdvOosCtaCLoaded = true;

  const blocks = '[data-mdv-oos-cta-c="20261022"]';

  function initialize(node) {
    if (node.dataset.mdvOosInitialized === 'true') return;
    const sectionId = node.dataset.mdvSection;
    const root = node.closest('product-info');
    const raw = document.querySelector('script[data-mdv-oos-cta-c-variants="' + sectionId + '"]');
    if (!root || !raw) return;

    let json;
    try { json = JSON.parse(raw.textContent); }
    catch (err) { console.warn('[MDV CTA C] Variant data unavailable', err); return; }
    if (!Array.isArray(json.variants)) return;

    const availability = new Map(json.variants.map(variant => [String(variant.id), variant.available === true]));
    const update = (id) => {
      if (!id || !availability.has(String(id))) {
        node.hidden = true;
        return;
      }
      node.hidden = availability.get(String(id));
    };

    node.dataset.mdvOosInitialized = 'true';
    const productPath = root.dataset.url || '';
    const currentURL = new URL(window.location.href);
    const urlVariant = currentURL.pathname === productPath ? currentURL.searchParams.get('variant') : null;
    const formVariant = root.querySelector('.product-variant-id')?.value;
    update(urlVariant || formVariant || node.dataset.mdvInitialVariant);

    root.addEventListener('change', (event) => {
      if (event.target.matches('.product-variant-id')) update(event.target.value);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (data?.event?.target && root.contains(data.event.target)) node.hidden = true;
      });
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId) !== String(sectionId)) return;
        update(data.variant?.id);
      });
    }
  }

  function initializeAll() {
    document.querySelectorAll(blocks).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('product-info:loaded', initializeAll);
})();
